<template>
  <b-overlay
    id="overlay-background"
    :show="historyLoader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-card
      :class="customChange ? 'list-group-item custom-curser' : 'custom-curser'"
    >
      <b-card-header
        class="case-logs-history-header"
      >
        <b-card-title>{{ $t('DEBTIA_CASE_LOGS_HISTORY') }}</b-card-title>
        <b-card-title class="text-primary">
        <!-- <drag-links
          :parent="8"
          :side="side"
          :custom-change="customChange"
        /> -->
        </b-card-title>
      </b-card-header>
      <!-- search here -->
      <b-form-group>
        <b-input-group>
          <b-form-input
            id="search"
            v-model="searchQuery"
            :placeholder="$t('DEBTIA_SEARCH')"
          />
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              @click="filterHistory()"
            >
              <feather-icon
                icon="FilterIcon"
              />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <div
        v-if="caseLogsData.length > 0"
        class="scroll-div"
      >
        <div
          v-for="(data,cldindex) in caseLogsData"
          :key="cldindex"
          class="mt-2"
        >
          <div>
            <b-card
              class="border mb-0"
            >
              <b-card-text class="card-text content-heading mb-35">
                <h4>
                  {{ $t('DEBTIA_DEBT_CASE_NOTES') }}
                </h4>
                <p>
                  {{ ($i18n.locale === 'en') ? data.en_log_created_at : data.da_log_created_at }}
                </p>
                <p>
                  {{ $t('DEBTIA_CREATED_BY') + " " + data.employee_name }}
                </p>
              </b-card-text>
              <div class="border mb-10 padding-content">
                <div
                  class="business-item"
                >
                  <div class="d-flex align-items-center justify-content-between">
                    <label
                      class="note-font"
                      v-html="data.note"
                    />
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
      <div
        v-else
      >
        There are no records found.
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  // BRow, BCol,
  BCard, BFormGroup, BButton, BInputGroup, BFormInput, BInputGroupAppend, BCardText, BCardHeader, BCardTitle, BOverlay,
  // BPagination,
} from 'bootstrap-vue'
// import store from '@/store'
// import router from '@/router'
// import { ref, reactive } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import constants from '@/app-configs/constants'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
// import i18n from '@/libs/i18n'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    // BRow,
    // BCol,
    BCard,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BCardText,
    BCardHeader,
    BCardTitle,
    BOverlay,
    // DragLinks,
    // BPagination,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      historyLoader: false,
      notestext: '',
      showNotesAlert: false,
      searchQuery: '',
      caseLogsData: [],
      userRoles: [],
      user_role: JSON.parse(localStorage.getItem('userData')).role[0],
    }
  },
  computed: {
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0) {
          this.getHistory()
        }
      },
    },
  },
  created() {
    this.getHistory()
    EventBus.$on('refreshLogs', () => {
      this.getHistory()
    })
    EventBus.$on('setUserRoles', data => {
      this.setUserRolesMethod(data)
    })
  },
  methods: {
    formatString(str) {
      const formattedText = str
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
      return formattedText
    },
    parseStr(content) {
      const obj = JSON.parse(content)
      const attributeNames = Object.keys(obj)
      let str = ''
      attributeNames.forEach(element => {
        if (element !== 'dated' && element !== 'time') {
          if (str) {
            str += '<br>'
          }
          str += `<strong>${this.formatString(element)}</strong>: ${obj[element]}`
        }
      })
      return str
    },
    setUserRolesMethod(data) {
      this.userRoles = data
    },
    getLink(attachments) {
      const att = JSON.parse(attachments)
      return att[0]
    },
    printTextWithoutTags(text) {
      const textWithoutTags = text.replace(/<[^>]*>/g, '')
      return textWithoutTags
    },
    async setStrLimit(id, action) {
      if (action === 'more') {
        if (this.caseLogsData.length > 0) {
          this.caseLogsData.forEach((element, index) => {
            if (element.id === id) {
              this.caseLogsData[index].isOpen = true
            }
          })
        }
      }
      if (action === 'less') {
        if (this.caseLogsData.length > 0) {
          this.caseLogsData.forEach((element, index) => {
            if (element.id === id) {
              this.caseLogsData[index].isOpen = false
            }
          })
        }
      }
    },
    async getHistory() {
      this.historyLoader = true
      const caseID = this.$route.params.id
      const url = `/debt-case/logs/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.historyLoader = false
          this.caseLogsData = response.data.data
        }
      })
    },
    getTitle(role) {
      const entry = this.userRoles.filter(record => record.value === role)
      let title = 'N/A'
      if (entry[0]) {
        title = entry[0].label
      }
      return title
    },
    UppercaseTransformation(str) {
      return str.split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    getLoggedInRoleId() {
      const entry = this.userRoles.filter(record => this.UppercaseTransformation(record.name) === this.UppercaseTransformation(this.user_role))
      let id = 0
      if (entry[0]) {
        id = entry[0].value
      }
      return id
    },
    canshow(contents) {
      let exists = false
      const loggedInRoleId = this.getLoggedInRoleId()
      const entry = contents.filter(record => record.role_id === loggedInRoleId)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
    getReceiver(str) {
      const att = JSON.parse(str)
      return att.to
    },
    async filterHistory() {
      if (this.searchQuery.length > 0) {
        this.historyLoader = true
        const caseID = this.$route.params.id
        const url = `/debt-case/logs/${caseID}?search=${this.searchQuery}`
        await axios.get(url).then(response => {
          if (response.status === 200) {
            this.historyLoader = false
            this.caseLogsData = response.data.data
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
.note-content-div {
  display: inline-block; width: 93%; min-height: 38px;
}

.content-heading {
  margin-bottom: 0px !important;
}

.custom-curser {
  cursor: default;
}

.scroll-div {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 600px;
  padding-right: 10px;
}

.scroll-div::-webkit-scrollbar {
    width: 12px;
}

.scroll-div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
</style>
